import React from 'react';
import {NeuroMessage, RenderOnlyFor, usePages} from "@ignitesales/neuro-application";
import classnames from "classnames";

const ReturnToSurveyButton = ({ className }) => {
    const { goToPreviousPage } = usePages();
    const componentClass = "returnToSurveyButton";
    const classes = classnames(componentClass, className);

    return <RenderOnlyFor forSummaryPage={true}>
        <div className={classes}>
            <button className="btn back-btn" onClick={goToPreviousPage}>
                <i className="ion-md-arrow-back"/>
                <NeuroMessage id='summary.previousPageBtn'/>
            </button>
        </div>
    </RenderOnlyFor>
};

export default ReturnToSurveyButton;
